// https://finproservices.nerdwallet.com/flask_admin/admincategorypage/

const EXCELLENT = 'excellent';
const GOOD = 'good';
const POOR = 'poor';
const AVERAGE = 'average';

export default {
  'airline-credit-cards': {
    default_credit_score_category: EXCELLENT,
    name: 'Airline Credit Cards',
  },
  'bad-credit-cards': {
    default_credit_score_category: POOR,
    name: 'Bad-Credit Credit Cards',
  },
  'secured-credit-cards': {
    default_credit_score_category: POOR,
    name: 'Secured Credit Cards',
  },
  'balance-transfer-credit-cards': {
    default_credit_score_category: GOOD,
    name: 'Balance Transfer Credit Cards',
  },
  'business-credit-cards': {
    default_credit_score_category: GOOD,
    name: 'Business Credit Cards',
  },
  'cash-rewards-credit-cards': {
    default_credit_score_category: GOOD,
    name: 'Cash Rewards Credit Cards',
  },
  'credit-card-bonus-offers': {
    default_credit_score_category: GOOD,
    name: 'Credit Card with Bonus Offers',
  },
  'gas-credit-cards': {
    default_credit_score_category: GOOD,
    name: 'Gas Credit Cards',
  },
  'low-apr-credit-cards': {
    default_credit_score_category: GOOD,
    name: 'Low APR Credit Cards',
  },
  'rewards-credit-cards': {
    default_credit_score_category: GOOD,
    name: 'Rewards Credit Cards',
  },
  'travel-miles-credit-cards': {
    default_credit_score_category: GOOD,
    name: 'Travel Miles Credit Cards',
  },
  'zero-percent-credit-cards': {
    default_credit_score_category: GOOD,
    name: 'Zero Percent Credit Cards',
  },
  'student-credit-cards': {
    default_credit_score_category: AVERAGE,
    name: 'Student Credit Cards',
  },
};
